import { MyPageUserPutInputModel } from "./PutInputModel"
import { PutMyPageUserResponse } from "./putResponse"
import { httpPut } from "src/libs/http/httpPut"

const endpointUrl = "/v1/mypage/user"

export const putMyPageUser = async (
  model: MyPageUserPutInputModel,
): Promise<PutMyPageUserResponse> => {
  return httpPut<PutMyPageUserResponse>(endpointUrl, model)
}
